import { render, staticRenderFns } from "./listpohon.vue?vue&type=template&id=2c05140e&"
import script from "./listpohon.vue?vue&type=script&lang=js&"
export * from "./listpohon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports